import { MISMO_FEE_LIST_ACTION_TYPE } from 'store/system/actions';

const initialState = [];

const feeTypeMismoReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MISMO_FEE_LIST_ACTION_TYPE.GET_LIST:
      return payload || initialState;

    default:
      return state;
  }
};

export default feeTypeMismoReducer;
